function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Lyriq-AI",
  transform: "translate(-642.000000, -1469.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ghostwriter",
  transform: "translate(81.000000, 1442.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "eye",
  transform: "translate(561.000000, 27.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M63,68 C44.2509191,68 29,52.7474143 29,34 C29,15.2525857 44.2509191,0 63,0 C81.7474144,0 97,15.2525857 97,34 C97,52.7474143 81.7474144,68 63,68 Z M62.9999998,7.90794561 C48.6123719,7.90794561 36.9062791,19.612372 36.9062791,34 C36.9062791,48.387628 48.6123719,60.0920544 62.9999998,60.0920544 C77.3859612,60.0920544 89.092054,48.387628 89.092054,34 C89.092054,19.612372 77.3876281,7.90794561 62.9999998,7.90794561 L62.9999998,7.90794561 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63,52 C53.0745969,52 45,43.9254031 45,34 C45,24.0745969 53.0745969,16 63,16 C72.9254035,16 81,24.0745969 81,34 C81,43.9254031 72.9254035,52 63,52 Z M63,23.8255132 C57.3898461,23.8255132 52.8255132,28.3898461 52.8255132,34 C52.8255132,39.6101539 57.3898461,44.1744868 63,44.1744868 C68.6101543,44.1744868 73.1728373,39.6101539 73.1728373,34 C73.1728373,28.3898461 68.6101543,23.8255132 63,23.8255132 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63.4431176,68 C39.6661974,68 17.4502021,56.8305477 0.890678243,36.5515417 C-0.293818351,35.1016126 -0.297164171,33.0233814 0.882312836,31.5701193 C17.4067039,11.2127837 39.626045,0 63.4431176,0 C87.3354759,0 109.591624,11.2127837 126.117687,31.5701193 C127.297164,33.0233814 127.293818,35.1016126 126.109322,36.5515417 C109.549798,56.8305477 87.2936506,68 63.4431176,68 L63.4431176,68 Z M9.15203688,34.0483309 C23.9180863,50.8708398 43.0824983,60.0937209 63.4431176,60.0937209 C83.8740034,60.0937209 103.078568,50.8708398 117.844617,34.0483309 C103.108682,17.1624919 83.9057905,7.90794561 63.4431176,7.90794561 C43.0507113,7.90794561 23.8862993,17.1624919 9.15203688,34.0483309 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.0836085,83 L7.91639108,83 C5.75346006,83 4,81.209106 4,79 C4,76.7908935 5.75346006,75 7.91639108,75 L47.0836085,75 C49.2465395,75 51,76.7908935 51,79 C51,81.209106 49.2465395,83 47.0836085,83 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.047936,97 L7.95206317,97 C5.76943129,97 4,95.2094839 4,93.0008429 C4,90.792202 5.76943129,89 7.95206317,89 L83.047936,89 C85.2305683,89 87,90.792202 87,93.0008429 C87,95.2094839 85.2305683,97 83.047936,97 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.031996,110 L7.96633182,110 C5.7758197,110 4,108.209484 4,105.999157 C4,103.790517 5.7758197,102 7.96633182,102 L119.033668,102 C121.222508,102 123,103.790517 123,105.999157 C123,108.209484 121.222508,110 119.031996,110 L119.031996,110 Z",
  id: "Path"
})))));

var SvgIconGhostwriter = function SvgIconGhostwriter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 110,
    viewBox: "0 0 127 110",
    fill: "#000",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconGhostwriter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_ghostwriter.9bb050ee.svg";
export { ForwardRef as ReactComponent };